export const buttonRootCss = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
};
